export const IMAGE = "https://i2.wp.com/asvs.in/wp-content/uploads/2017/08/dummy.png?fit=399%2C275";
export const defaultImage = "http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg";
export const contractorImage = "https://s3.dev.houselink.info/uploads/1547306288830-JFZN9Uq.png";



// WEBPACK FOOTER //
// ./src/constants/dummy.js